import type { IconData } from '@stacksjs/iconify-core'

export const vc1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#f4f100\" d=\"M0 0h510.4v512H0z\"/><path fill=\"#199a00\" d=\"M385.6 0H512v512H385.6z\"/><path fill=\"#0058aa\" d=\"M0 0h126.4v512H0z\"/></g><path fill=\"#199a00\" fill-rule=\"evenodd\" d=\"m191.2 138.6l-49.5 76.2l47.8 79.3l46.7-78.6zm129.4 0L271 214.8l47.7 79.3l46.8-78.6l-45-76.9zm-65.4 103.9l-49.4 76.1l47.7 79.4l46.7-78.7z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default vc1x1
